import { LoginResponseDto } from "@/data/dto/login-response-dto";
import { LoginResponseInfoEntity } from "@/domain/entity/login-response-info-entity";
import { assertLoginResponseDto } from "@/utils/validation/generated/login-response-dto.validator";

export class LoginResponseInfoMapper {
  static toEntity(dto: LoginResponseDto): LoginResponseInfoEntity {
    assertLoginResponseDto(dto);

    return {
      accessToken: dto.accessToken,
      refreshToken: dto.refreshToken,
      isExpiredSn: Boolean(dto.isExpiredSn),
      id: dto.id,
      email: dto.email,
      name: dto.name,
      role: dto.role,
    };
  }
}
